export default "__VITE_ASSET__B6cCn$mm__"